export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIME_OUT = 10;
export const RESULT_PER_PAGE = 10;
export const KEY = '2251e438-dd79-4bea-9421-fb0d5a8973a9';
